import { useNavigate, useSearchParams } from "react-router-dom";
import { LoginForm as BaseLoginForm } from "@racoon/ui";
import { AuthResponse } from "@racoon/api";
import { LogoSentinel } from "@racoon/icons";
import {
  useLoginMutation,
  useSendOtpMutation,
  useLoginOtpMutation,
} from "../../../../shared/api/auth/auth.api";

export const LoginForm = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const defaultMode = searchParams.get("method") === "sms" ? "otp" : "password";
  const loginMutation = useLoginMutation();
  const sendOtpMutation = useSendOtpMutation();
  const loginOtpMutation = useLoginOtpMutation();

  const handleSuccess = (_data: AuthResponse) => {
    navigate("/dashboard");
  };

  const handleForgotPassword = () => {
    navigate("/forgot-password");
  };

  return (
    <BaseLoginForm
      loginMutation={loginMutation}
      sendOtpMutation={sendOtpMutation}
      loginOtpMutation={loginOtpMutation}
      onSuccess={handleSuccess}
      onForgotPassword={handleForgotPassword}
      defaultMode={defaultMode}
      isGrpc={true}
      logo={<LogoSentinel className="h-14 w-auto shrink-0 md:h-24" />}
    />
  );
};
